import { SearchFilterViewsType } from 'js/constants/visibilityFilters';
import * as React from 'react';
import { ForwardedRef, forwardRef, useRef } from 'react';
import { InputProps } from 'react-select/dist/declarations/src/components/Input';
import { useConst } from '../../hooks/useConst';
import { useScope } from '../../hooks/useScope';
import { setRef } from '../../tools/setRef';
import { MacroInput, MacroInputApi, MacroInputProps } from './MacroInput';
import { ignoreKeys } from './tools/ignoreKeys';

export interface MacroAutocompleteInputProps {
  api: InputProps<any, false, any>;
  view: SearchFilterViewsType;
  placeholder?: string;
  onChange?: MacroInputProps['onChange'];
  onFocus?: MacroInputProps['onFocus'];
  onBlur?: MacroInputProps['onBlur'];
}

export const MacroAutocompleteInput = forwardRef(
  (props: MacroAutocompleteInputProps, inputRef: ForwardedRef<MacroInputApi>) => {
    const scope = useScope(props);
    const ref = useRef<MacroInputApi>();

    return useConst(() => {
      const triggerChangeOnEvent = () => {
        const { triggerChangeWithCurrentSegment } = ref.current;
        triggerChangeWithCurrentSegment(scope.api.onChange);
      };

      const onTextChange = (text?: string) => {
        if (!text) {
          const current = ref.current?.getCurrentSegment();
          if (current?.segment) return;
        }
        triggerChangeOnEvent();
      };

      return (
        <MacroInput
          ref={setRef(inputRef, ref)}
          view={scope.view}
          style="border: 0; box-shadow: none !important; width: 100%;"
          placeholder={
            scope.placeholder || 'Search for IDs, names, tags, connection types, and more...'
          }
          clearSelectionOnBlur={true}
          onSelect={triggerChangeOnEvent}
          onDeselect={triggerChangeOnEvent}
          onMacroChange={triggerChangeOnEvent}
          onTextChange={onTextChange}
          onChange={(value) => scope.onChange?.(value)}
          onKeyDown={ignoreKeys}
          onKeyUp={ignoreKeys}
          onFocus={(e) => scope.onFocus?.(e)}
          onBlur={(e) => scope.onBlur?.(e)}
        />
      );
    });
  },
);
